define('editor/edit/map/configHelpers',['durandal/app'], function (app) {
  var viewmodel = function () {
    var self = this;

    self.mapEditorMapConfigToLeafletTilelayerProps = function(mapConfig, layerConfig) {
      if (!layerConfig) {
        return null;
      }
      
      var isMapTilerTileProvider = mapConfig.mapTilerApiKey != null;
      var useMapboxStaticAPI = !isMapTilerTileProvider && /^.+\/.+$/.test(layerConfig.id); // 'username/<map_id>'

      var tileUrlTemplate = isMapTilerTileProvider
          ? "https://api.maptiler.com/maps/{id}/256/{z}/{x}/{y}.{e}?key={token}"
          : useMapboxStaticAPI
              ? "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={token}" // Static API format
              : "https://{s}.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.{e}?access_token={token}"; // "Classic" tile layer format

      tileUrlTemplate = tileUrlTemplate.replace("{e}", layerConfig.extension || "png");

      var tileLayerOptions = {
          id: layerConfig.id, 
          token: isMapTilerTileProvider ? mapConfig.mapTilerApiKey : mapConfig.mapboxApiKey,
      };
      
      // if using mapbox static API template and the default 512px tiles, pass in these options otherwise everything looks tiny
      if (useMapboxStaticAPI) {
          tileLayerOptions.tileSize = 512;
          tileLayerOptions.zoomOffset = -1;
      }

      return {
          tileLayerUrlTemplate: tileUrlTemplate,
          tileLayerOptions: tileLayerOptions
      };
    };

  }

  return new viewmodel();
});

